import { mapRecordsFromServer } from 'coreOld/mappers';
import { partfinitiClient } from 'coreOld/services';
import { IOption } from 'coreOld/types';

export const getMany = async (signal?: AbortSignal) => {
  const { data } = await partfinitiClient.get('/support/level-list/levels', signal);

  return mapRecordsFromServer<IOption>(data.data, data.recordsFiltered);
};
